import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { StandaloneComponents } from '@documents-v2/standalone-components';
import { DocumentsFormsModule } from '@forms/documents/documents-forms.module';
import { TableModule } from '@table/table.module';
import { DocumentsV2Resolver } from './documents-v2.resolver';
import { DocumentsV2RouterModule } from './documents-v2.routes';
import { Services } from './services';
import { CompanyDocumentDeletionModal, Views } from './views';

@NgModule({
    imports: [
        AppCommonModule,
        CommonModule,
        CompanyDocumentDeletionModal,
        DocumentsFormsModule,
        DocumentsV2RouterModule,
        FormsModule,
        PlatformModule,
        ReactiveFormsModule,
        TableModule,
        StandaloneComponents,
    ],
    declarations: [...Views],
    providers: [DocumentsV2Resolver, ...Services],
    exports: [...Views],
})
export class DocumentsV2Module {}
